/* eslint-disable no-unused-vars */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { CommonAxiosResponse } from 'src/types';
import Api from 'src/services/ApiService';
import {
  CreateCreditNoteRequest,
  CreateTransactionRequest,
  CreateTransactionResponse,
  CreateCreditNoteResponse,
  GetRmaInventoryRequest,
  GetRmaInventoryResponse
} from './types';

export const getRmaInventoryThunk = createAsyncThunk<
  CommonAxiosResponse<GetRmaInventoryResponse>, // fix later
  GetRmaInventoryRequest
>('rma-inventory/getRmaInventoryThunk', async (data) => {
  const response = await Api.get('/rma/inventory/get', { ...data, limit: 15 }); // change once api is avaialbe
  return response;
});

export const createCreditNoteThunk = createAsyncThunk<
  CommonAxiosResponse<CreateCreditNoteResponse>,
  CreateCreditNoteRequest
>('rma-inventory/createCreditNoteThunk', async (data) => {
  const response = await Api.post('/rma/inventory/credit_note/create', data);
  return response;
});

export const createTransactionThunk = createAsyncThunk<
  CommonAxiosResponse<CreateTransactionResponse>,
  CreateTransactionRequest
>('rma-inventory/createTransactionThunk', async (data) => {
  const response = await Api.post('/rma/inventory/transaction/create', data);
  return response;
});
